export function BackToTopIcon () {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" style={{ fill: "rgba(0, 0, 0, 0.3)", pointerEvents: "none", stroke: "#fff" }}>
  <path style={{ strokeWidth: 1 }} d="M44 0H0v44h44" />
  <path style={{ strokeWidth: 1.5 }} d="M30.588 27.233L22 18.366l-8.588 8.867-1.078-1.043L22 16.21l9.666 9.98-1.078 1.043" />
</svg>

  )
}